export const TOKEN_REFRESH_THRESHOLD = 60000; // ms (1min)

export const USER_GROUPS = {
  AUTHENTICATION: 'AUTHENTICATION',
} as const;

export const USER_PERMISSIONS = {
  [USER_GROUPS.AUTHENTICATION]: ['AUTHENTICATION_LOGIN'],
} as const;
